import { memo } from 'react'
import { css } from '@emotion/react'
import { Field } from 'react-final-form'
import FormLabel from '~/components/finalForms/atoms/FormLabel'
import RenderRadioButton from '~/components/finalForms/atoms/RenderRadioButton'

const GenderField = ({must, id="gender"}) => {
  return(
    <div css={inputUnit}>
      <FormLabel must={must}>性別</FormLabel>
      <div css={inputForm}>
        <Field
          id={id}
          name={id}
          labels={["女性", "男性"]}
          vals={[2, 1]}
          defaultValue={2}
          component={RenderRadioButton}
        />
      </div>
    </div>
  )
}

export default memo(GenderField);

const inputUnit = css`
  /* width: 400px; */
  display: flex;
  flex-direction: column;
`;

const inputForm = css`
  display: flex;
`;

const styledRadio = css`
  display: flex;
`;

